import { Typography } from '@mui/material';
import { useContext } from 'react';

import GettingStarted from '../components/GettingStarted';
import Install from '../components/Install';
import Leaderboard from '../components/Leaderboard';

import { UserContext } from '../components/UserContex';

const Home = () => {
  const user = useContext(UserContext);

  return (
    <>
      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '20px' }} gutterBottom>
        Hei på deg! 👋 {!user && 'Velkommen til Fotballyst!'}
      </Typography>
      {user ? <Leaderboard /> : <GettingStarted />}
      <Install />
    </>
  );
};

export default Home;
